import { render, staticRenderFns } from "./AudienceSuggestionAgent.vue?vue&type=template&id=e5cea9ea&scoped=true"
import script from "./AudienceSuggestionAgent.vue?vue&type=script&lang=js"
export * from "./AudienceSuggestionAgent.vue?vue&type=script&lang=js"
import style0 from "./AudienceSuggestionAgent.vue?vue&type=style&index=0&id=e5cea9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cea9ea",
  null
  
)

export default component.exports